import React, { Component } from "react";
import { authService } from "../../auth";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import uuid from "react-uuid";
import AuthModalComponent from "../../LoginExtra/AuthModalComponent";
import CommonHashTagsStudio from "./Common/CommonHashTagsStudio";

class HashTagsStudios extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginSuccess: authService.isAuthenticated(),
            loginRequired: false
        }
    }

    handleLoginClose = () => {
        this.setState({
            loginRequired: false
        }, () => {
            window.$("#loginModal").modal("hide");
        })
    }

    render() {
        return (
            <div id="hashTagStudio" className="expHashSection expHashPhotos">
                <h2 className="edtrdsk">Studios</h2>
                <div className="explLatarticle">
                    <OwlCarousel
                        id={"expHashPhotosCarousel"}
                        className={"expHashPhotosCarousel"}
                        autoWidth={true}
                        nav={false}
                        dots={false}
                        margin={12}
                        key={uuid()}
                        items={3}
                        loop={false}
                        rewind={true}
                    >
                        {this.props.studioListData && this.props.studioListData.slice(0, 3).map((item, idx) => {
                                return (
                                    <div className="item paidProjColmn" key={idx}>
                                        <CommonHashTagsStudio item={item} key={item.id} idx={idx} />
                                    </div>
                                );
                            })
                        }
                    </OwlCarousel>
                    {this.props.studioListData && this.props.studioListData.length > 3 &&
                        <div className="btnblock text-center">
                            {(this.props.hashTagType === 'global' ? (
                                <Link className="btn morebtnsm" to={`/explore-hashtag/studios/${this.props.tagName}`}>View All</Link>
                                ) : 
                                this.props?.hashTagType === "COMMUNITY" ? 
                                (<Link className="btn morebtnsm" to={`/community/hashtag/studios/${this.props.tagName}/${this.props.userName}`}>View All</Link>) :
                                (<Link className="btn morebtnsm" to={`/profile-hashtag/studios/${this.props.tagName}/${this.props.userName}`}>View All</Link>)
                            )}
                        </div>
                    }
                    {this.state.loginRequired === true ? (
                        <AuthModalComponent handleLoginClose={this.handleLoginClose} pathname={`/explore-hashtag/studios/${this.props.tagName}`} />
                    ) : null}
                </div>
            </div>
        )
    }
}

export default HashTagsStudios;